import React, { useState, forwardRef, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Typography,
  Row,
  Col,
  Button,
  message,
  DatePicker,
} from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import "./Patientdetails.css";
import moment from "moment";
// InputMask replaced by patient-app pattern (plain Input + formatDateString)

import dayjs from "dayjs";
// Remove react-date-picker imports
// import DatePicker from 'react-date-picker';
// import 'react-date-picker/dist/DatePicker.css';
// import 'react-calendar/dist/Calendar.css';

import "react-international-phone/style.css";
import {
  PhoneInput,
  getCountries,
  getCountryCallingCode,
} from "react-international-phone";
import { pushTraceLogEvent, logInteraction } from "./sessionEventPush";
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

const Patientdetails = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const today = dayjs();
  const minDate = today.subtract(120, "year");
  const [dob, setDob] = useState("");
  const dobFieldRef = useRef(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [dobError, setDobError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);

  const [fullPhone, setFullPhone] = useState("");
  const [formInfo, setFormInfo] = useState({
    email: "",
    mobile: "",
  });  
  // const [showCouponInput, setShowCouponInput] = useState(false);
  // const [couponCode, setCouponCode] = useState("");
  // const [couponApplied, setCouponApplied] = useState(false);
  // const [couponDiscount, setCouponDiscount] = useState(0);
  // const [applyingCoupon, setApplyingCoupon] = useState(false);
  const [promoCodeId, setPromoCodeId] = useState(null);
  const {applyCoupon,setCouponCode,couponCode,applyingCoupon,showCouponInput,setShowCouponInput,couponApplied,setCouponApplied,couponDiscount,setCouponDiscount,isReschedule} = props;
  useEffect(() => {
    const patientData = props?.getAllHealthScreenData?.showAppoinmentData?.data?.patient;
    if (patientData?.country_code && patientData?.mobile_number) {
      const combined = patientData.country_code + patientData.mobile_number;
      setFullPhone(combined);
      props?.form?.setFieldsValue({ phone: combined });
    } else {
      const formPhone = props?.form?.getFieldValue('phone');
      setFullPhone(formPhone || '');
    }
  }, [props?.form, props?.getAllHealthScreenData?.showAppoinmentData]);

  // Sync the visible `dob` Input when the form is pre-populated with patient data or cleared
  useEffect(() => {
    const prefilled = props?.form?.getFieldValue('date_of_birth');
    if (!prefilled) {
      setDob('');
    } else {
      let formatted = '';
      if (prefilled && typeof prefilled.format === 'function') {
        // moment or dayjs object
        formatted = prefilled.format('DD/MM/YYYY');
      } else if (typeof prefilled === 'string' && prefilled.includes('-')) {
        // YYYY-MM-DD string from backend
        formatted = dayjs(prefilled, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else if (typeof prefilled === 'string') {
        formatted = prefilled;
      }
      setDob(formatted);
    }
  }, [props?.form, props?.form?.getFieldValue('date_of_birth')]);


  const handleChange = (e) => {
    const { id, value } = e?.target || {};
    setFormInfo((prev) => {
      const updated = {
        ...prev,
        [id]: value,
      };
      return updated;
    });
  };
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email);
  const isValidPhone = (phone) => {
    if (!phone) return false;
    const digitsOnly = phone.replace(/\D/g, "");
    return digitsOnly.length >= 10;
  };
  useEffect(() => {
    // NOTE: was previously guarded on `formInfo.patient_details_email`, a field
    // that is never populated (the actual input id/field name is `email`),
    // which meant this event never fired. Fixed to use the real field.
    if (!formInfo.email) return;

    const timer = setTimeout(() => {
      if (isValidEmail(formInfo.email)) {
        pushTraceLogEvent({
          event: "entered_email_address",
          payload: {
            email: formInfo.email,
            name: props?.form?.getFieldValue("first_name") || "",
            patient_data_filled: true,
            date: new Date().toISOString().split("T")[0],
          },
          step_status: "success",
        });
        // setLogged((prev) => ({ ...prev, email: true }));
      }
    }, 800);
    return () => clearTimeout(timer);
  }, [formInfo.email]);

  const logPatientDetail = (eventName, fieldPayload) => {
    const hasValue = Object.values(fieldPayload || {}).some(
      (v) => v !== undefined && v !== null && v !== "",
    );
    if (!hasValue) return;
    pushTraceLogEvent({
      event: eventName,
      payload: {
        ...fieldPayload,
        patient_data_filled: true,
        date: new Date().toISOString().split("T")[0],
      },
      step_status: "success",
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isValidPhone(formInfo.mobile)) {
        pushTraceLogEvent({
          event: "entered_phone_number",
          payload: {
            phone: formInfo.mobile,
            name: props?.form?.getFieldValue("first_name") || "",
            patient_data_filled: true,
            date: new Date().toISOString().split("T")[0],
          },
          step_status: "success",
        });
        // setLogged((prev) => ({ ...prev, phone: true }));
      }
    }, 800);
    return () => clearTimeout(timer);
  }, [formInfo.mobile]);

  const isInvalidDateByRange = (date) => {
    if (!date) return;
    const now = dayjs();
    const oldestAllowed = dayjs().subtract(120, "year");
    if (date.isAfter(now, "day")) {
      messageApi.error({
        type: "error",
        content: "Future Date",
      });
    }
    if (date.isBefore(oldestAllowed, "day")) {
      messageApi.error({
        type: "error",
        content: "Too Old (120+ years)",
      });
    }
  };

  const validatePhoneNumber = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject("Phone number is required");
    }
    const digitsOnly = value.replace(/\D/g, "");
    if (digitsOnly.length < 6) {
      return Promise.reject("Please enter a valid phone number");
    }
    return Promise.resolve();
  };

  const handlePhoneChange = (value, metadata) => {
    const countryCode = "+" + metadata.country.dialCode;
    let localNumber = value.replace(countryCode, "").trim();
    if (localNumber.startsWith("0")) {
      localNumber = localNumber.replace(/^0+/, "");
      value = countryCode + localNumber;
    }
    setFullPhone(value);
    props?.form?.setFieldsValue({
      country_code: countryCode,
      mobile_number: localNumber,
      appointment_reason: undefined,
    });
    if (props.onFormChange) {
      props.onFormChange({}, props?.form.getFieldsValue());
    }
  };


  // ---- Patient-app DOB helpers (mirrors Step4.js in ldcbe-patient) ----
  const formatDateString = (input, isDeleting = false) => {
    if (!input) return "";
    let cleaned = input.replace(/\D/g, "");
    if (cleaned.length > 8) cleaned = cleaned.slice(0, 8);
    
    if (cleaned.length > 4) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4)}`;
    } else if (cleaned.length === 4) {
      return isDeleting ? `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}` : `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/`;
    } else if (cleaned.length > 2) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    } else if (cleaned.length === 2) {
      return isDeleting ? cleaned : `${cleaned}/`;
    }
    return cleaned;
  };

  const isValidDate = (dateString) => {
    if (!dateString) return false;
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false;
    const [day, month, year] = dateString.split("/").map(Number);
    if (year < 1900) return false;
    if (month < 1 || month > 12) return false;
    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;
    return day > 0 && day <= monthLength[month - 1];
  };

  const handleDobChange = (e) => {
    const isDeleting = e.nativeEvent && e.nativeEvent.inputType === "deleteContentBackward";
    const formatted = formatDateString(e.target.value, isDeleting);
    setDob(formatted);
    if (!isValidDate(formatted)) {
      setDobError("Please enter a valid date in DD/MM/YYYY format");
      props?.form?.setFieldsValue({ date_of_birth: undefined });
    } else {
      setDobError("");
      props?.form?.setFieldsValue({ date_of_birth: dayjs(formatted, "DD/MM/YYYY") });
      props?.form?.validateFields(["date_of_birth"]);
      setIsDatePickerOpen(false);
      logPatientDetail("patient_dob_entered", { date_of_birth: formatted });
    }
  };

  const handleDobBlur = () => {
    if (dob) {
      const parts = dob.split("/");
      const day = parts[0]?.padStart(2, "0") || "";
      const month = parts[1]?.padStart(2, "0") || "";
      const year = parts[2] || "";
      const formatted = `${day}${day ? "/" : ""}${month}${month && year ? "/" : ""}${year}`;
      if (formatted !== dob) setDob(formatted);
    }
  };

  const handleCalendarPick = (date) => {
    if (date) {
      const formatted = date.format("DD/MM/YYYY");
      setDob(formatted);
      setDobError("");
      props?.form?.setFieldsValue({ date_of_birth: date });
      props?.form?.validateFields(["date_of_birth"]);
      logPatientDetail("patient_dob_entered", { date_of_birth: formatted });
    }
    setIsDatePickerOpen(false);
  };

  const handlePhoneInputChange = (value, country, e) => {
    // existing phone logic
    handlePhoneChange(value, country, e);

    // adapt to handleChange shape
    handleChange({
      target: {
        id: "mobile",
        value,
      },
    });
  };
  return (
    <div style={{ width: "100%", backgroundColor: "#fff", padding: "10px 0" }}>
      {contextHolder}
      <Title
        level={4}
        style={{
          fontWeight: "400",
          background: "#00838540",
          borderRadius: "5px",
          padding: 10,
          color: "#008385",
          textAlign: "center",
        }}
      >
        Patient details
      </Title>
      <div
        style={{
          width: "393px",
          backgroundColor: "#fff",
          padding: "5px",
          margin: "auto",
        }}
      >
        <Form.Item
          name="first_name"
          rules={[{ required: true, message: "First name is required" }]}
        >
          <Input
            placeholder="First name"
            className="custom-placeholder"
            name="first_name"
            autoComplete="off"
            onBlur={(e) => logPatientDetail("patient_first_name_entered", { first_name: e.target.value })}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
          />
        </Form.Item>
        <Form.Item
          name="last_name"
          rules={[{ required: true, message: "Last name is required" }]}
        >
          <Input
            className="custom-placeholder"
            name="last_name"
            autoComplete="off"
            onBlur={(e) => logPatientDetail("patient_last_name_entered", { last_name: e.target.value })}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
            placeholder="Last Name"
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="gender"
              style={{ textAlign: "left", color: "#000" }}
              rules={[{ required: true, message: "Gender name is required" }]}
            >
              <Select
                bordered={false}
                style={{
                  border: "none",
                  borderBottom: "1px solid #000",
                  borderRadius: 0,
                  boxShadow: "none",
                  paddingLeft: 0,
                  color: "#000",
                  textAlign: "left",
                }}
                className="custom-placeholder-option"
                placeholder="Select gender"
                onBlur={() => logPatientDetail("patient_gender_selected", { gender: props?.form?.getFieldValue("gender") })}
              >
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12} style={{ position: 'relative' }} ref={dobFieldRef}>
            {/* Date of Birth — Form.Item wraps visible input so error renders below */}
            <Form.Item
              name="date_of_birth"
              rules={[
                { required: true, message: 'Date of birth is required' },
                {
                  validator: (_, val) => {
                    if (!val) return Promise.resolve();
                    let d;
                    if (val && typeof val.isAfter === 'function') {
                      d = dayjs.isDayjs(val) ? val : dayjs(val.toDate ? val.toDate() : val);
                    } else if (typeof val === 'string') {
                      d = val.includes('/') ? dayjs(val, 'DD/MM/YYYY') : dayjs(val);
                    } else {
                      return Promise.resolve();
                    }
                    if (!d.isValid()) return Promise.reject('Please enter a valid date');
                    if (!d.isBefore(dayjs(), 'day')) return Promise.reject('Please enter a valid date of birth. The date must be before today.');
                    if (d.isBefore(dayjs().subtract(120, 'year'), 'day')) return Promise.reject('Date is too old');
                    return Promise.resolve();
                  }
                }
              ]}
              style={{ marginBottom: 24 }}
            >
              {/* Visible: plain Input with calendar icon — value controlled via setFieldsValue */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid #000',
                height: 32,
              }}>
                <Input
                  id="dob"
                  value={dob}
                  placeholder="DD/MM/YYYY"
                  autoComplete="off"
                  onClick={() => setIsDatePickerOpen(true)}
                  onKeyDown={(e) => {
                    const allowed = ['Backspace','Delete','Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Enter','Escape','/'];
                    if (e.ctrlKey || e.metaKey) return;
                    if (!allowed.includes(e.key) && !/^\d$/.test(e.key)) e.preventDefault();
                  }}
                  onChange={handleDobChange}
                  onBlur={handleDobBlur}
                  style={{
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    fontSize: 14,
                    color: '#000',
                    flex: 1,
                    minWidth: 0,
                    paddingLeft: 0,
                    boxShadow: 'none',
                  }}
                  suffix={
                    <CalendarOutlined
                      style={{ color: '#008385', cursor: 'pointer', fontSize: 14 }}
                      onClick={() => setIsDatePickerOpen(true)}
                    />
                  }
                />
              </div>
            </Form.Item>
            {/* Invisible DatePicker — popup only */}
            <div style={{ position: 'absolute', top: 32, left: 0, opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}>
              <DatePicker
                format="DD/MM/YYYY"
                disabledDate={(current) => current && (!current.isBefore(dayjs(), 'day') || current.isBefore(minDate, 'day'))}
                showToday={false}
                allowClear={false}
                open={isDatePickerOpen}
                onOpenChange={setIsDatePickerOpen}
                value={dob && isValidDate(dob) ? dayjs(dob, 'DD/MM/YYYY') : null}
                onChange={handleCalendarPick}
                popupClassName="dob-picker-popup"
                placement="bottomLeft"
                getPopupContainer={() => dobFieldRef.current || document.body}
              />
            </div>
          </Col>
        </Row>
        <Form.Item
          name="email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input
            placeholder="Contact email"
            className="custom-placeholder"
            autoComplete="off"
            onChange={handleChange}
            // onBlur={(e) => {
            //   if (e.target.value !== formInfo.email) {
            //     setFormInfo((prev) => ({
            //       ...prev,
            //       email: e.target.value,
            //     }));
            //   }
            // }}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
          />
        </Form.Item>

        <Form.Item
          name="phone"
          rules={[{ validator: validatePhoneNumber }]}
          getValueFromEvent={(value) => value}
          validateTrigger={["onBlur"]}
        >
          <PhoneInput
            defaultCountry="gb"
            value={fullPhone}
            onFocus={() => setPhoneTouched(true)}
            onChange={(value, country, e) => {
              handlePhoneInputChange(value, country, e);
              // Sync value into form field so validation sees it
              props?.form?.setFieldsValue({ phone: value });
              // Skip validation until the user has actually focused the field —
              // react-international-phone fires an onChange with just the default
              // dial code on mount, which would otherwise show "invalid phone" by default.
              if (phoneTouched) {
                props?.form?.validateFields(["phone"]).catch(() => {});
              }
            }}
            inputStyle={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
              width: "100%",
            }}
            className="phoneInputCss"
            countrySelectorStyleProps={{
              buttonStyle: {
                border: "none",
                borderBottom: "1px solid #000",
                borderRadius: 0,
                paddingLeft: 0,
              },
            }}
            placeholder="Mobile number"
          />
        </Form.Item>

        {props?.getAllHealthScreenData?.showAppoinmentData?.clinic
          ?.productCategory?.type === 'corporate' && (
          <>
            {(props?.calenderData?.patient?.member_number ||
              props?.getAllHealthScreenData?.showAppoinmentData?.clinic
                ?.selectedCorporate?.requires_employee_number) && (
              <Form.Item
                name="member_number"
                rules={[
                  {
                    required:
                      props?.getAllHealthScreenData?.showAppoinmentData?.clinic
                        ?.selectedCorporate?.requires_employee_number,
                    message: "Vitality membership number is required",
                  },
                ]}
              >
                <Input
                  placeholder="Vitality membership number"
                  className="custom-placeholder"
                  name="member_number"
                  autoComplete="off"
                  onBlur={(e) => logPatientDetail("patient_member_number_entered", { member_number: e.target.value })}
                  style={{
                    border: "none",
                    borderBottom: "1px solid #000",
                    borderRadius: 0,
                    boxShadow: "none",
                    paddingLeft: 0,
                  }}
                />
              </Form.Item>
            )}
          </>
        )}

        <Form.Item
          name="address_1"
          rules={[
            {
              required: true,
              message: "Address line 1 is required",
            },
          ]}
        >
          <Input
            placeholder="Address line 1"
            className="custom-placeholder"
            name="address_1"
            autoComplete="off"
            onBlur={(e) => logPatientDetail("patient_address_line1_entered", { address_1: e.target.value })}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
          />
        </Form.Item>
        <Form.Item
          name="address_2"
          rules={[
            { required: false, message: "Address line 2 is required" },
          ]}
        >
          <Input
            placeholder="Address line 2"
            className="custom-placeholder"
            autoComplete="off"
            onBlur={(e) => logPatientDetail("patient_address_line2_entered", { address_2: e.target.value })}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
          />
        </Form.Item>
        <Form.Item
          name="city"
          rules={[
            {
              required: true,
              message: "City is required",
            },
          ]}
        >
          <Input
            placeholder="City"
            className="custom-placeholder"
            name="city"
            autoComplete="off"
            onBlur={(e) => logPatientDetail("patient_city_entered", { city: e.target.value })}
            style={{
              border: "none",
              borderBottom: "1px solid #000",
              borderRadius: 0,
              boxShadow: "none",
              paddingLeft: 0,
            }}
          />
        </Form.Item>
        <Form.Item
              name="country"
              label={
                <div style={{ color: "#008385", fontSize: 16 }}>
                  Country/region
                </div>
              }
              style={{
                margin: "auto",
                width: 393,
                marginTop: 15,
                textAlign: "left",
                marginBottom: "20px",
              }}
            >
              <Row gutter={8}>
                <Col span={24}>
                  <Select
                    placeholder="United Kingdom"
                    style={{
                      color: "#008385",
                      fontSize: 16,
                      textAlign: "left",
                      background: "#F0FAFA",
                      borderRadius: 20,
                      // marginTop: "20px",
                    }}
                    bordered={false}
                    onChange={(value) => {
                      props.setSelectedCountry(value);
                      props.form.setFieldsValue({ country: value });
                      setTimeout(() => {
                        props.form.validateFields(["postalCode1"]);
                      }, 0);
                      logPatientDetail("patient_country_selected", { country: value });
                    }}
                    defaultValue="United kingdom"
                  >
                    {props?.countryNames?.map((country) => (
                      <Select.Option
                        value={country}
                        style={{ color: "#008385" }}
                      >
                        {country}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              name="postalCode1"
              rules={[
                {
                  required: true,
                  message: "Postal Code is required",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value) return Promise.resolve();

                    const trimmedValue = value.replace(/\s+/g, "");
                    const country = getFieldValue("country") || "UK";
                    if (
                      country === "United Kingdom (UK)" &&
                      props.specialPostcodes.includes(
                        trimmedValue.toUpperCase(),
                      )
                    ) {
                      return Promise.resolve();
                    }
                    let isValid = false;
                    let errorMessage = "Please enter a valid postal code";

                    props.countries.registerLocale(props.enLocale);
                    const trimmedName = props.selectedCountry?.trim();
                    // console.log(props.selectedCountry, "selectedCountry");

                    const clean = trimmedName
                      ?.replace(/\s*\(.*?\)\s*/g, "")
                      ?.trim();
                    const countryCode = props.countries?.getAlpha2Code(
                      clean,
                      "en",
                    );
                    // console.log("countryCode",countryCode);

                    if (
                      trimmedValue == undefined ||
                      countryCode == undefined
                    ) {
                      return Promise.resolve();
                    }
                    props.countries.registerLocale(props.enLocale);

                    if (
                      !props.postcodeValidatorExistsForCountry(countryCode)
                    ) {
                      console.warn(
                        `Postal code validation not supported for: ${countryCode}`,
                      );
                      return Promise.resolve();
                    }
                    isValid = props.postcodeValidator(
                      trimmedValue,
                      countryCode,
                    );
                    return isValid
                      ? Promise.resolve()
                      : Promise.reject(new Error(errorMessage));
                  },
                }),
              ]}
            >
              <Input
                placeholder="Postal Code"
                className="custom-placeholder"
                name="postalCode1"
                autoComplete="off"
                onChange={(e) => {
                  props.form.setFieldsValue({
                    postalCode1: e.target.value,
                  });
                }}
                onBlur={(e) => logPatientDetail("patient_postcode_entered", { postcode: e.target.value })}
                style={{
                  border: "none",
                  borderBottom: "1px solid #000",
                  borderRadius: 0,
                  boxShadow: "none",
                  paddingLeft: 0,
                }}
              />
            </Form.Item>

        {/* Hidden fields for backend */}
        <Form.Item name="country_code" noStyle>
          <input type="hidden" />
        </Form.Item>

        <Form.Item name="mobile_number" noStyle>
          <input type="hidden" />
        </Form.Item>

        {props.getAllHealthScreenData?.allGPproduct &&
        props.getAllHealthScreenData?.showAppoinmentData?.clinic
          ?.productCategory?.type === 'gp' ? (
          <Form.Item
            name="appointment_reason"
            style={{ textAlign: "left", color: "#000" }}
          >
            <Select
              allowClear
              placeholder="Reason for the appointment"
              className="custom-placeholder-option"
              bordered={false}
              style={{
                border: "none",
                borderBottom: "1px solid #000",
                borderRadius: 0,
                boxShadow: "none",
                paddingLeft: 0,
                color: "#008385",
                textAlign: "left",
              }}
              onBlur={() => logPatientDetail("patient_appointment_reason_selected", { appointment_reason: props?.form?.getFieldValue("appointment_reason") })}
            >
              {props.getAllHealthScreenData?.allGPproduct?.map((prodcat, i) => {
                return (
                  <React.Fragment key={prodcat.gp_product_id ?? i}>
                    {prodcat.status == 1 ? (
                      <Option value={prodcat.gp_product_id.toString()}>
                        {prodcat.name}
                      </Option>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                );
              })}
            </Select>
          </Form.Item>
        ) : (
          ""
        )}
        <Form.Item name="comment">
          <TextArea
            placeholder="Health concerns / Notes for your GP"
            onBlur={(e) => logPatientDetail("patient_comment_entered", { comment: e.target.value })}
          />
        </Form.Item>
        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject("You must agree to continue"),
            },
          ]}
        >
          <Checkbox
            className="term-cond"
            onClick={(e) => logInteraction("terms_checkbox_toggled", { checked: e.target.checked })}
            style={{
              display: "flex",
              alignItems: "flex-start",
              textAlign: "left",
            }}
          >
            <span style={{ textAlign: "left" }}>
              I agree with the overall{" "}
              <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/">
                Cancellation and Refunds Policy
              </a>
              . Information on how we use your data, can be found in our{" "}
              <a href="https://www.londondoctorsclinic.co.uk/terms-conditions/privacy-policy/">
                Privacy Notice
              </a>
            </span>
          </Checkbox>
        </Form.Item>
        <Form.Item
          name="marketing"
          valuePropName="checked"
          style={{ marginBottom: 0 }}
        >
          <Checkbox
            className="term-cond"
            onClick={(e) => logInteraction("marketing_checkbox_toggled", { checked: e.target.checked })}
            style={{
              display: "flex",
              alignItems: "flex-start",
              textAlign: "left",
            }}
          >
            <span style={{ textAlign: "left" }}>
              I agree to receive <a href="#">Marketing Communications</a> from
              London Doctors Clinic.
            </span>
          </Checkbox>
        </Form.Item>
        {/* Coupon Section */}
        {!isReschedule && (
        <div className="coupon-section" style={{ marginTop: "20px", marginBottom: "20px", textAlign: "left" }}>
          {!couponApplied ? (
            <div
              style={{
                textAlign: "left",
                fontSize: "16px",
                fontWeight: "400",
                marginBottom: "10px",
                display: "inline-block",
              }}
              onClick={() => {
                logInteraction("coupon_input_toggled", { opened: !showCouponInput });
                setShowCouponInput(!showCouponInput);
              }}
            >
              <span>Have a coupon? </span> <span style={{ color: "#008385", cursor: "pointer", }}>Click here to enter your code</span>
            </div>
          ) : (
            <div style={{
              textAlign: "left",
              marginBottom: "10px",
              padding: "10px",
              backgroundColor: "#e8f5e9",
              borderRadius: "4px",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: "14px", color: "#2e7d32", fontWeight: "500", marginBottom: "4px" }}>
                    ✓ Coupon Applied
                  </div>
                  <div style={{ fontSize: "13px", color: "#555" }}>
                    Discount: £{Number(couponDiscount || 0).toFixed(2)}
                  </div>
                </div>
                <Button
                  type="link"
                  onClick={() => {
                    logInteraction("coupon_removed", { coupon_code: couponCode, discount: couponDiscount });
                    setCouponApplied(false);
                    setCouponCode("");
                    setCouponDiscount(0);
                    setPromoCodeId(null);
                    setShowCouponInput(false);
                  }}
                  style={{ color: "#d32f2f", padding: "4px 8px" }}
                >
                  Remove
                </Button>
              </div>
            </div>
          )}
          {showCouponInput && !couponApplied && (
            <div style={{ maxWidth: "393px", margin: "auto", marginTop: "10px" }}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Input
                  placeholder="Enter coupon code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  style={{ flex: 1 }}
                />
                <Button
                  type="primary"
                  onClick={(e) => {
                    logInteraction("coupon_apply_clicked", { coupon_code: couponCode });
                    props.applyCoupon(e);
                  }}
                  loading={applyingCoupon}
                  disabled={!couponCode.trim()}
                  style={{
                    backgroundColor: "#008385",
                    borderColor: "#008385",
                  }}
                >
                  <span style={{ fontSize: "14px", color: 'white' }}>Apply</span>
                </Button>
              </div>
            </div>
          )}
        </div>
        )}
      </div>
    </div>
  );
};

export default Patientdetails;
